import React, { useState } from 'react';
import PropTypes from 'prop-types';
import './frequencyQuestion.css';

/**
 * FrequencyQuestion
 * Componente de pregunta de frecuencia con opciones configurables por label.
 * Si no recibe labels, usa opciones base:
 * "Siempre", "Casi siempre", "Algunas veces", "Casi nunca", "Nunca".
 * Solo permite una seleccion y muestra un error si es required y no se selecciona nada.
 * Devuelve valor numerico segun criterio de evaluacion;
 * si invertOrder=true, invierte el rango (primera opcion=0 ... ultima opcion=max).
 */
const FrequencyQuestion = ({
  question,
  required = false,
  field,
  value = null,
  updateProgress,
  invertOrder = false,
  labels = null
}) => {
  const [touched, setTouched] = useState(false);
  const error = required && touched && (value === null || value === undefined);

  const baseOptions = [
    { label: 'Siempre' },
    { label: 'Casi siempre' },
    { label: 'Algunas veces' },
    { label: 'Casi nunca' },
    { label: 'Nunca' }
  ];

  const effectiveLabels = Array.isArray(labels) && labels.length > 0
    ? labels
    : baseOptions.map((opt) => opt.label);

  const options = effectiveLabels.map((label, idx) => ({
    label,
    value: invertOrder ? idx : effectiveLabels.length - 1 - idx
  }));

  const handleChange = (num) => {
    updateProgress(num);
    setTouched(true);
  };

  return (
    <div className={`frequency-question${error ? ' error' : ''}`}>
      <label className="question-label">
        {question} {required && <span className="required">*</span>}
      </label>
      <div className="frequency-options">
        {options.map((opt) => (
          <label key={`${field}-${opt.value}-${opt.label}`} className="option-label">
            <input
              type="radio"
              name={field}
              value={opt.value}
              checked={value === opt.value}
              onChange={() => handleChange(opt.value)}
              onBlur={() => setTouched(true)}
            />
            {opt.label}
          </label>
        ))}
      </div>
      {error && <p className="error-text">Este campo es obligatorio.</p>}
    </div>
  );
};

FrequencyQuestion.propTypes = {
  question: PropTypes.string.isRequired,
  required: PropTypes.bool,
  field: PropTypes.string.isRequired,
  value: PropTypes.number,
  updateProgress: PropTypes.func.isRequired,
  invertOrder: PropTypes.bool,
  labels: PropTypes.arrayOf(PropTypes.string)
};

FrequencyQuestion.defaultProps = {
  required: false,
  value: null,
  invertOrder: false,
  labels: null
};

export default FrequencyQuestion;
